var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c(
        "b-navbar",
        { attrs: { toggleable: "lg" } },
        [
          _c(
            "b-navbar-nav",
            { attrs: { tabs: "" } },
            [
              _vm.$store.state.authUser.flag === "Admin"
                ? _c(
                    "b-nav-item",
                    { attrs: { to: _vm.subPath.pendingAction } },
                    [_vm._v("\n        Pending\n      ")]
                  )
                : _vm._e(),
              _c("b-nav-item", { attrs: { to: _vm.subPath.viewInfo } }, [
                _vm._v("View")
              ]),
              _vm.$store.state.authUser.flag === "Admin" ||
              _vm.$store.state.authUser.flag == "Trn"
                ? _c("b-nav-item", { attrs: { to: _vm.subPath.report } }, [
                    _vm._v("Report")
                  ])
                : _vm._e(),
              _vm.$store.state.authUser.flag === "Admin" ||
              _vm.$store.state.authUser.flag == "Con"
                ? _c("b-nav-item", { attrs: { to: _vm.subPath.management } }, [
                    _vm._v("Management")
                  ])
                : _vm._e(),
              _vm.$store.state.authUser.flag === "Admin" ||
              _vm.$store.state.authUser.flag == "Con"
                ? _c(
                    "b-nav-item",
                    { attrs: { to: _vm.subPath.registration } },
                    [_vm._v("Registration")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f9b5e44", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f9b5e44","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/dashboard/DashboardNavBar.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2f9b5e44","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/dashboard/DashboardNavBar.vue
// module chunks = 9